import _DesignerPortal from './DesignerPortal';

export const DesignerPortal = _DesignerPortal;
